import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { FEATURE_KEY } from './constants';
import { claimCmeCeReducer } from './reducer';
import { ClaimCmeCeEffects } from './effects';

@NgModule({
  declarations: [],
  imports: [
    StoreModule.forFeature(FEATURE_KEY, claimCmeCeReducer),
    EffectsModule.forFeature([ClaimCmeCeEffects])
  ]
})
export class ClaimCmeCeStoreModule { }
